module.exports = __webpack_public_path__ + "assets/img/termal-power.35438345.png";